// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"584":"8716d5eb","910":"57b8d02b"}[chunkId] + ".chunk.css";
};